import(/* webpackMode: "eager" */ "/app/app/(providers)/robotic-surgery-detailpage/page.js");
